export default __webpack_public_path__ + "static/media/delete.84bf1daf.svg";